import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9735601c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title", "alt", "src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("img", {
    class: "img",
    title: `Foto de ${_ctx.name}`,
    alt: `Foto de ${_ctx.name}`,
    src: _ctx.image,
    onError: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadFallbackImage($event)))
  }, null, 40, _hoisted_1))
}